// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"ChatsPage_chatContainer__3jNas"};